export default "__VITE_ASSET__BpLnz3Bt__"